import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';

const MyPreset = definePreset(Aura, {
    semantic: {
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '#fcfbf9',
                    100: '#f3efe6',
                    150: '#EBE7DE',
                    200: '#e2ddd4',
                    300: '#cdc5b6',
                    400: '#C2BA9C',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}',
                    black: '#1a1919',
                    disabled: '#eee'
                },

                primary: {
                    color: '#8f1c3e',
                    0: '#ffffff',
                    50: '#F9F3F5',
                    100: '#F4E9EC',
                    200: '#E9D2D8',
                    300: '#DEBBC6',
                    400: '#D2A4B2',
                    500: '#C68D9E',
                    600: '#BC778B',
                    700: '#B16178',
                    800: '#A54965',
                    900: '#9B3352',
                    950: '#952848'
                },

                green: {
                    color: '#46a82b',
                    0: '#ffffff',
                    50: '#EDF7EA',
                    100: '#DAEED5',
                    300: '#C8E5C0',
                    400: '#90CB80',
                    500: '#46a82b',
                    700: '#2A621B'
                },

                formField: {
                    borderRadius: '20px',
                    background: '{surface.0}',
                    borderColor: '{surface.300}',
                    hoverBorderColor: '{primary.color}',
                    focusBorderColor: '{primary.500}',
                    disabledBackground: '{surface.disabled}',
                    disabledColor: '{surface.500}'
                },


                list: {
                    option: {
                        selected: {
                            background: '{surface-200}',
                            hover: { background: '{surface-200}', color: '{surface-black}' },
                            focus: { background: '{surface-200}', color: '{surface-black}' },
                            color: '{surface-black}'
                        },
                        hover: { background: '{surface-50}' }
                    },
                    header: {
                        padding: '6px'
                    }
                },

                content: {
                    background: '#ffffff',
                    border: {
                        radius: '12px',
                        color: '{surface-300}'
                    }
                }
            },

            overlay: {
                modal: {
                    padding: '20px',
                    shadow: '0 20px 25px 5px rgba(0,0,0,0.4),0 8px 10px -6px rgba(0,0,0,0.3)'
                }
            }
        }
    },
    components: {
        chip: {
            root: {
                padding: {
                    x: '12px',
                    y: '4px'
                },
                border: {
                    radius: '20px'
                }
            }
        },

        paginator: {
            root: {
                background: '{surface.0}',
                padding: '16px 20px',
                border: {
                    radius: '0',
                    color: '{surface.300}'
                },
                nav: {
                    button: {
                        width: '30px',
                        height: '30px',

                        selected: {
                            background: '{surface.200}',
                            color: '{primary.color}'
                        },

                        hover: {
                            background: '{surface.100}'
                        }
                    }
                }
            }

        },

        toast: {
            root: {
                boxShadow: '0 0 20px 4px rgba(0, 0, 0, 1)'
            }
        },

        progressbar: {
            root: {
                border: {
                    radius: '0px'
                },
                background: 'transparent',
                height: '1px'
            }
        },

        fieldset: {
            root: {
                background: '{surface-50}',
                padding: '12px',
                border: {
                    radius: '12px',
                    color: '{surface-300}'
                }
            }

        },

        inputchips: {
            root: {
                borderRadius: '8px'
            }
        },

        avatar: {
            background: '{content.border.color}',
            border: {
                radius: '{content.border.radius}'
            },
            color: '{content.color}',
            figma: {
                circle: {
                    border: {
                        radius: '{avatar.width} / 2'
                    },
                    lg: {
                        border: {
                            radius: '{avatar.lg.width} / 2'
                        }
                    },
                    xl: {
                        border: {
                            radius: '{avatar.xl.width} / 2'
                        }
                    }
                }
            },
            font: {
                size: '1rem'
            },
            group: {
                border: {
                    color: '{content.background}'
                },
                offset: '-0.75rem'
            },
            height: '2rem',
            icon: {
                size: '1rem'
            },
            lg: {
                font: {
                    size: '1.5rem'
                },
                group: {
                    offset: '-1rem'
                },
                height: '3rem',
                icon: {
                    size: '1.5rem'
                },
                width: '3rem'
            },
            width: '2rem',
            xl: {
                font: {
                    size: '2rem'
                },
                group: {
                    offset: '-1.5rem'
                },
                height: '4rem',
                icon: {
                    size: '2rem'
                },
                width: '4rem'
            }
        },
        button: {
            badge: {
                size: '1rem'
            },
            border: {
                radius: '{form.field.border.radius}'
            },
            contrast: {
                active: {
                    background: '{surface.200}',
                    border: {
                        color: '{surface.200}'
                    },
                    color: '{surface.950}'
                },
                background: '{surface.0}',
                border: {
                    color: '{surface.0}'
                },
                color: '{surface.950}',
                focus: {
                    ring: {
                        color: '{surface.0}'
                    }
                },
                hover: {
                    background: '{surface.100}',
                    border: {
                        color: '{surface.100}'
                    },
                    color: '{surface.950}'
                }
            },
            danger: {
                active: {
                    background: '{red.200}',
                    border: {
                        color: '{red.200}'
                    },
                    color: '{red.950}'
                },
                background: '{red.400}',
                border: {
                    color: '{red.400}'
                },
                color: '{red.950}',
                focus: {
                    ring: {
                        color: '{red.400}'
                    }
                },
                hover: {
                    background: '{red.300}',
                    border: {
                        color: '{red.300}'
                    },
                    color: '{red.950}'
                }
            },
            figma: {
                lg: {
                    icon: {
                        size: '{button.lg.font.size}'
                    }
                },
                raised: {
                    background: 'rgba(0,0,0,0.01)'
                },
                sm: {
                    icon: {
                        size: '{button.sm.font.size}'
                    }
                }
            },
            focus: {
                ring: {
                    offset: '{focus.ring.offset}',
                    style: '{focus.ring.style}',
                    width: '{focus.ring.width}'
                }
            },
            gap: '0.5rem',
            help: {
                active: {
                    background: '{purple.200}',
                    border: {
                        color: '{purple.200}'
                    },
                    color: '{purple.950}'
                },
                background: '{purple.400}',
                border: {
                    color: '{purple.400}'
                },
                color: '{purple.950}',
                focus: {
                    ring: {
                        color: '{purple.400}'
                    }
                },
                hover: {
                    background: '{purple.300}',
                    border: {
                        color: '{purple.300}'
                    },
                    color: '{purple.950}'
                }
            },
            icon: {
                only: {
                    width: '2.5rem'
                }
            },
            info: {
                active: {
                    background: '{sky.200}',
                    border: {
                        color: '{sky.200}'
                    },
                    color: '{sky.950}'
                },
                background: '{sky.400}',
                border: {
                    color: '{sky.400}'
                },
                color: '{sky.950}',
                focus: {
                    ring: {
                        color: '{sky.400}'
                    }
                },
                hover: {
                    background: '{sky.300}',
                    border: {
                        color: '{sky.300}'
                    },
                    color: '{sky.950}'
                }
            },
            label: {
                font: {
                    weight: '500'
                }
            },
            lg: {
                font: {
                    size: '1.125rem'
                },
                icon: {
                    only: {
                        width: '3rem'
                    }
                },
                padding: {
                    x: '0.875rem',
                    y: '0.625rem'
                }
            },
            link: {
                active: {
                    color: '{primary.color}'
                },
                color: '{primary.color}',
                hover: {
                    color: '{primary.color}'
                }
            },
            outlined: {
                contrast: {
                    active: {
                        background: '{surface.700}'
                    },
                    border: {
                        color: '{surface.500}'
                    },
                    color: '{surface.0}',
                    hover: {
                        background: '{surface.800}'
                    }
                },
                danger: {
                    active: {
                        background: '{red.400}'
                    },
                    border: {
                        color: '{red.700}'
                    },
                    color: '{red.400}',
                    hover: {
                        background: '{red.400}'
                    }
                },
                help: {
                    active: {
                        background: '{purple.400}'
                    },
                    border: {
                        color: '{purple.700}'
                    },
                    color: '{purple.400}',
                    hover: {
                        background: '{purple.400}'
                    }
                },
                info: {
                    active: {
                        background: '{sky.400}'
                    },
                    border: {
                        color: '{sky.700}'
                    },
                    color: '{sky.400}',
                    hover: {
                        background: '{sky.400}'
                    }
                },
                plain: {
                    active: {
                        background: '{surface.700}'
                    },
                    border: {
                        color: '{surface.600}'
                    },
                    color: '{surface.0}',
                    hover: {
                        background: '{surface.800}'
                    }
                },
                primary: {
                    active: {
                        background: '{primary.color}'
                    },
                    border: {
                        color: '{primary.700}'
                    },
                    color: '{primary.color}',
                    hover: {
                        background: '{primary.color}'
                    }
                },
                secondary: {
                    active: {
                        background: 'rgba(255, 255, 255, 0.16)'
                    },
                    border: {
                        color: '{surface.700}'
                    },
                    color: '{surface.400}',
                    hover: {
                        background: 'rgba(255, 255, 255, 0.04)'
                    }
                },
                success: {
                    active: {
                        background: '{green.400}'
                    },
                    border: {
                        color: '{green.700}'
                    },
                    color: '{green.400}',
                    hover: {
                        background: '{green.400}'
                    }
                },
                warn: {
                    active: {
                        background: '{orange.400}'
                    },
                    border: {
                        color: '{orange.700}'
                    },
                    color: '{orange.400}',
                    hover: {
                        background: '{orange.400}'
                    }
                }
            },
            padding: {
                x: '{form.field.padding.x}',
                y: '{form.field.padding.y}'
            },
            primary: {
                active: {
                    background: '{primary.active.color}',
                    border: {
                        color: '{primary.active.color}'
                    },
                    color: '{primary.contrast.color}'
                },
                background: '{primary.color}',
                border: {
                    color: '{primary.color}'
                },
                color: '{primary.contrast.color}',
                focus: {
                    ring: {
                        color: '{primary.color}'
                    }
                },
                hover: {
                    background: '{primary.hover.color}',
                    border: {
                        color: '{primary.hover.color}'
                    },
                    color: '{primary.contrast.color}'
                }
            },
            rounded: {
                border: {
                    radius: '2rem'
                }
            },
            secondary: {
                active: {
                    background: '{surface.600}',
                    border: {
                        color: '{surface.600}'
                    },
                    color: '{surface.100}'
                },
                background: '{surface.800}',
                border: {
                    color: '{surface.800}'
                },
                color: '{surface.300}',
                focus: {
                    ring: {
                        color: '{surface.300}'
                    }
                },
                hover: {
                    background: '{surface.700}',
                    border: {
                        color: '{surface.700}'
                    },
                    color: '{surface.200}'
                }
            },
            sm: {
                font: {
                    size: '0.875rem'
                },
                icon: {
                    only: {
                        width: '2rem'
                    }
                },
                padding: {
                    x: '0.625rem',
                    y: '0.375rem'
                }
            },
            success: {
                active: {
                    background: '{green.200}',
                    border: {
                        color: '{green.200}'
                    },
                    color: '{green.950}'
                },
                background: '{green.400}',
                border: {
                    color: '{green.400}'
                },
                color: '{green.950}',
                focus: {
                    ring: {
                        color: '{green.400}'
                    }
                },
                hover: {
                    background: '{green.300}',
                    border: {
                        color: '{green.300}'
                    },
                    color: '{green.950}'
                }
            },
            text: {
                contrast: {
                    active: {
                        background: '{surface.700}'
                    },
                    color: '{surface.0}',
                    hover: {
                        background: '{surface.800}'
                    }
                },
                danger: {
                    active: {
                        background: '{red.400}'
                    },
                    color: '{red.400}',
                    hover: {
                        background: '{red.400}'
                    }
                },
                help: {
                    active: {
                        background: '{purple.400}'
                    },
                    color: '{purple.400}',
                    hover: {
                        background: '{purple.400}'
                    }
                },
                info: {
                    active: {
                        background: '{sky.400}'
                    },
                    color: '{sky.400}',
                    hover: {
                        background: '{sky.400}'
                    }
                },
                plain: {
                    active: {
                        background: '{surface.700}'
                    },
                    color: '{surface.0}',
                    hover: {
                        background: '{surface.800}'
                    }
                },
                primary: {
                    active: {
                        background: '{primary.color}'
                    },
                    color: '{primary.color}',
                    hover: {
                        background: '{primary.color}'
                    }
                },
                secondary: {
                    active: {
                        background: '{surface.700}'
                    },
                    color: '{surface.400}',
                    hover: {
                        background: '{surface.800}'
                    }
                },
                success: {
                    active: {
                        background: '{green.400}'
                    },
                    color: '{green.400}',
                    hover: {
                        background: '{green.400}'
                    }
                },
                warn: {
                    active: {
                        background: '{orange.400}'
                    },
                    color: '{orange.400}',
                    hover: {
                        background: '{orange.400}'
                    }
                }
            },
            transition: {
                duration: '{form.field.transition.duration}'
            },
            warn: {
                active: {
                    background: '{orange.200}',
                    border: {
                        color: '{orange.200}'
                    },
                    color: '{orange.950}'
                },
                background: '{orange.400}',
                border: {
                    color: '{orange.400}'
                },
                color: '{orange.950}',
                focus: {
                    ring: {
                        color: '{orange.400}'
                    }
                },
                hover: {
                    background: '{orange.300}',
                    border: {
                        color: '{orange.300}'
                    },
                    color: '{orange.950}'
                }
            }
        },
        card: {
            background: '{content.background}',
            body: {
                gap: '0.5rem',
                padding: '1.25rem'
            },
            border: {
                radius: '{border.radius}'
            },
            caption: {
                gap: '0.5rem'
            },
            color: '{content.color}',
            subtitle: {
                color: '{text.muted.color}'
            },
            title: {
                font: {
                    size: '1.25rem',
                    weight: '500'
                }
            }
        },
        checkbox: {
            root: {
                border: {
                    color: '{primary.color}',
                    width: '2px',
                    radius: '20px'
                },
                hover: {
                    background: '{surface.black}',
                    border: {
                        color: '{surface.black}'
                    }
                },

                checked: {
                    hover: {
                        background: '{surface.black}',
                        border: {
                            color: '{surface.black}'
                        }
                    }
                }
            },
            background: '{form.field.background}',
            border: {
                color: '{form.field.border.color}',
                radius: '20px'
            },
            checked: {
                background: '{primary.color}',
                border: {
                    color: '{primary.color}'
                },
                disabled: {
                    border: {
                        color: '{form.field.border.color}'
                    }
                },
                focus: {
                    border: {
                        color: '{primary.color}'
                    }
                },
                hover: {
                    background: '{surface.black}',
                    border: {
                        color: '{surface.black}'
                    }
                }
            },
            disabled: {
                background: '{form.field.disabled.background}'
            },
            filled: {
                background: '{form.field.filled.background}'
            },
            focus: {
                border: {
                    color: '{form.field.border.color}'
                },
                ring: {
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                    style: '{focus.ring.style}',
                    width: '{focus.ring.width}'
                }
            },
            height: '1.25rem',
            hover: {
                border: {
                    color: '{form.field.hover.border.color}'
                }
            },
            icon: {
                checked: {
                    color: '{primary.contrast.color}',
                    hover: {
                        color: '{primary.contrast.color}'
                    }
                },
                color: '{form.field.color}',
                disabled: {
                    color: '{form.field.disabled.color}'
                },
                lg: {
                    size: '1rem'
                },
                size: '0.875rem',
                sm: {
                    size: '0.75rem'
                }
            },
            invalid: {
                border: {
                    color: '{form.field.invalid.border.color}'
                }
            },
            lg: {
                height: '1.5rem',
                width: '1.5rem'
            },
            shadow: '{form.field.shadow}',
            sm: {
                height: '1rem',
                width: '1rem'
            },
            transition: {
                duration: '{form.field.transition.duration}'
            },
            width: '1.25rem'
        },
        datatable: {
            body: {
                cell: {
                    border: {
                        color: '{datatable.border.color}'
                    },
                    lg: {
                        padding: '1rem 1.25rem'
                    },
                    padding: '0.75rem 1rem',
                    selected: {
                        border: {
                            color: '{primary.900}'
                        }
                    },
                    sm: {
                        padding: '0.375rem 0.5rem'
                    }
                }
            },
            border: {
                color: '{surface.800}'
            },
            column: {
                footer: {
                    font: {
                        weight: '600'
                    }
                },
                resizer: {
                    width: '0.5rem'
                },
                title: {
                    font: {
                        weight: '600'
                    }
                }
            },
            drop: {
                point: {
                    color: '{primary.color}'
                }
            },
            filter: {
                constraint: {
                    border: {
                        radius: '{list.option.border.radius}'
                    },
                    color: '{list.option.color}',
                    focus: {
                        background: '{list.option.focus.background}',
                        color: '{list.option.focus.color}'
                    },
                    list: {
                        gap: '{list.gap}',
                        padding: '{list.padding}'
                    },
                    padding: '{list.option.padding}',
                    selected: {
                        background: '{list.option.selected.background}',
                        color: '{list.option.selected.color}',
                        focus: {
                            background: '{list.option.selected.focus.background}',
                            color: '{list.option.selected.focus.color}'
                        }
                    },
                    separator: {
                        border: {
                            color: '{content.border.color}'
                        }
                    }
                },
                inline: {
                    gap: '0.5rem'
                },
                overlay: {
                    popover: {
                        background: '{overlay.popover.background}',
                        border: {
                            color: '{overlay.popover.border.color}',
                            radius: '{overlay.popover.border.radius}'
                        },
                        color: '{overlay.popover.color}',
                        gap: '0.5rem',
                        padding: '{overlay.popover.padding}',
                        shadow: '{overlay.popover.shadow}'
                    },
                    select: {
                        background: '{overlay.select.background}',
                        border: {
                            color: '{overlay.select.border.color}',
                            radius: '{overlay.select.border.radius}'
                        },
                        color: '{overlay.select.color}',
                        shadow: '{overlay.select.shadow}'
                    }
                },
                rule: {
                    border: {
                        color: '{content.border.color}'
                    }
                }
            },
            footer: {
                background: '{content.background}',
                border: {
                    color: '{datatable.border.color}',
                    width: '1px'
                },
                cell: {
                    background: '{content.background}',
                    border: {
                        color: '{datatable.border.color}'
                    },
                    color: '{content.color}',
                    lg: {
                        padding: '1rem 1.25rem'
                    },
                    padding: '0.75rem 1rem',
                    sm: {
                        padding: '0.375rem 0.5rem'
                    }
                },
                color: '{content.color}',
                lg: {
                    padding: '1rem 1.25rem'
                },
                padding: '0.75rem 1rem',
                sm: {
                    padding: '0.375rem 0.5rem'
                }
            },
            header: {
                background: '{content.background}',
                border: {
                    color: '{datatable.border.color}',
                    width: '1px'
                },
                cell: {
                    background: '{content.background}',
                    border: {
                        color: '{datatable.border.color}'
                    },
                    color: '{content.color}',
                    focus: {
                        ring: {
                            color: '{focus.ring.color}',
                            offset: '-1px',
                            shadow: '{focus.ring.shadow}',
                            style: '{focus.ring.style}',
                            width: '{focus.ring.width}'
                        }
                    },
                    gap: '0.5rem',
                    hover: {
                        background: '{content.hover.background}',
                        color: '{content.hover.color}'
                    },
                    lg: {
                        padding: '1rem 1.25rem'
                    },
                    padding: '0.75rem 1rem',
                    selected: {
                        background: '{highlight.background}',
                        color: '{highlight.color}'
                    },
                    sm: {
                        padding: '0.375rem 0.5rem'
                    }
                },
                color: '{content.color}',
                lg: {
                    padding: '1rem 1.25rem'
                },
                padding: '0.75rem 1rem',
                sm: {
                    padding: '0.375rem 0.5rem'
                }
            },
            loading: {
                icon: {
                    size: '2rem'
                }
            },
            paginator: {
                bottom: {
                    border: {
                        color: '{datatable.border.color}',
                        width: '1'
                    }
                },
                top: {
                    border: {
                        color: '{datatable.border.color}',
                        width: '1'
                    }
                }
            },
            resize: {
                indicator: {
                    color: '{primary.color}',
                    width: '1px'
                }
            },
            row: {
                background: '{content.background}',
                color: '{content.color}',
                focus: {
                    ring: {
                        color: '{focus.ring.color}',
                        offset: '-1px',
                        shadow: '{focus.ring.shadow}',
                        style: '{focus.ring.style}',
                        width: '{focus.ring.width}'
                    }
                },
                hover: {
                    background: '{content.hover.background}',
                    color: '{content.hover.color}'
                },
                selected: {
                    background: '{highlight.background}',
                    color: '{highlight.color}'
                },
                striped: {
                    background: '{surface.950}'
                },
                toggle: {
                    button: {
                        border: {
                            radius: '{datatable.row.toggle.button.size} / 2'
                        },
                        color: '{text.muted.color}',
                        focus: {
                            ring: {
                                color: '{focus.ring.color}',
                                offset: '{focus.ring.offset}',
                                shadow: '{focus.ring.shadow}',
                                style: '{focus.ring.style}',
                                width: '{focus.ring.width}'
                            }
                        },
                        hover: {
                            background: '{content.hover.background}',
                            color: '{text.color}'
                        },
                        selected: {
                            hover: {
                                background: '{content.background}',
                                color: '{primary.color}'
                            }
                        },
                        size: '1.75rem'
                    }
                }
            },
            sort: {
                icon: {
                    color: '{text.muted.color}',
                    hover: {
                        color: '{text.hover.muted.color}'
                    },
                    size: '0.875rem'
                }
            },
            transition: {
                duration: '{transition.duration}'
            }
        },
        datepicker: {
            buttonbar: {
                border: {
                    color: '{content.border.color}'
                },
                padding: '0.5rem 0 0 0'
            },
            date: {
                border: {
                    radius: '{datepicker.date.width} / 2'
                },
                color: '{content.color}',
                focus: {
                    ring: {
                        color: '{focus.ring.color}',
                        offset: '{focus.ring.offset}',
                        shadow: '{focus.ring.shadow}',
                        style: '{focus.ring.style}',
                        width: '{focus.ring.width}'
                    }
                },
                height: '2rem',
                hover: {
                    background: '{content.hover.background}',
                    color: '{content.hover.color}'
                },
                padding: '0.25rem',
                range: {
                    selected: {
                        background: '{highlight.background}',
                        color: '{highlight.color}'
                    }
                },
                selected: {
                    background: '{primary.color}',
                    color: '{primary.contrast.color}'
                },
                width: '2rem'
            },
            day: {
                view: {
                    margin: '0.5rem 0 0 0'
                }
            },
            dropdown: {
                active: {
                    background: '{surface.600}',
                    border: {
                        color: '{form.field.border.color}'
                    },
                    color: '{surface.100}'
                },
                background: '{surface.800}',
                border: {
                    color: '{form.field.border.color}',
                    radius: '{form.field.border.radius}'
                },
                color: '{surface.300}',
                focus: {
                    ring: {
                        color: '{focus.ring.color}',
                        offset: '{focus.ring.offset}',
                        shadow: '{focus.ring.shadow}',
                        style: '{focus.ring.style}',
                        width: '{focus.ring.width}'
                    }
                },
                hover: {
                    background: '{surface.700}',
                    border: {
                        color: '{form.field.border.color}'
                    },
                    color: '{surface.200}'
                },
                lg: {
                    width: '3rem'
                },
                sm: {
                    width: '2rem'
                },
                width: '2.5rem'
            },
            group: {
                border: {
                    color: '{content.border.color}'
                },
                gap: '{overlay.popover.padding}'
            },
            header: {
                background: '{content.background}',
                border: {
                    color: '{content.border.color}'
                },
                color: '{content.color}',
                padding: '0 0 0.5rem 0'
            },
            input: {
                icon: {
                    color: '{form.field.icon.color}'
                }
            },
            month: {
                border: {
                    radius: '{content.border.radius}'
                },
                padding: '0.375rem',
                view: {
                    margin: '0.5rem 0 0 0'
                }
            },
            panel: {
                background: '{content.background}',
                border: {
                    color: '{content.border.color}',
                    radius: '{content.border.radius}'
                },
                color: '{content.color}',
                padding: '{overlay.popover.padding}',
                shadow: '{overlay.popover.shadow}'
            },
            select: {
                month: {
                    border: {
                        radius: '{content.border.radius}'
                    },
                    color: '{content.color}',
                    hover: {
                        background: '{content.hover.background}',
                        color: '{content.hover.color}'
                    },
                    padding: '0.25rem 0.5rem'
                },
                year: {
                    border: {
                        radius: '{content.border.radius}'
                    },
                    color: '{content.color}',
                    hover: {
                        background: '{content.hover.background}',
                        color: '{content.hover.color}'
                    },
                    padding: '0.25rem 0.5rem'
                }
            },
            time: {
                picker: {
                    border: {
                        color: '{content.border.color}'
                    },
                    button: {
                        gap: '0.25rem'
                    },
                    gap: '0.5rem',
                    padding: '0.5rem 0 0 0'
                }
            },
            title: {
                font: {
                    weight: '500'
                },
                gap: '0.5rem'
            },
            today: {
                background: '{surface.700}',
                color: '{surface.0}'
            },
            transition: {
                duration: '{transition.duration}'
            },
            week: {
                day: {
                    color: '{content.color}',
                    font: {
                        weight: '500'
                    },
                    padding: '0.25rem'
                }
            },
            year: {
                border: {
                    radius: '{content.border.radius}'
                },
                padding: '0.375rem',
                view: {
                    margin: '0.5rem 0 0 0'
                }
            }
        },
        dialog: {
            background: '{overlay.modal.background}',
            border: {
                color: '{overlay.modal.border.color}',
                radius: '{overlay.modal.border.radius}'
            },
            color: '{overlay.modal.color}',
            content: {
                padding: '0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}'
            },
            footer: {
                gap: '0.5rem',
                padding: '0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}'
            },
            header: {
                gap: '0.5rem',
                padding: '12px'
            },
            shadow: '{overlay.modal.shadow}',
            title: {
                font: {
                    size: '1.25rem',
                    weight: '600'
                }
            }
        },
        drawer: {
            background: '{overlay.modal.background}',
            border: {
                color: '{overlay.modal.border.color}',
                radius: '{overlay.modal.border.radius}'
            },
            color: '{overlay.modal.color}',
            content: {
                padding: 0
            },
            footer: {
                padding: '{overlay.modal.padding}'
            },
            header: {
                padding: '8px 12px'
            },
            shadow: '{overlay.modal.shadow}',
            title: {
                font: {
                    size: '1.5rem',
                    weight: '600'
                }
            }
        },
        fileupload: {
            background: '{content.background}',
            basic: {
                gap: '0.5rem'
            },
            border: {
                color: '{content.border.color}',
                radius: '{content.border.radius}'
            },
            color: '{content.color}',
            content: {
                gap: '1rem',
                highlight: {
                    border: {
                        color: '{primary.color}'
                    }
                },
                padding: '0 1.125rem 1.125rem 1.125rem'
            },
            file: {
                border: {
                    color: '{content.border.color}'
                },
                gap: '1rem',
                info: {
                    gap: '0.5rem'
                },
                list: {
                    gap: '0.5rem'
                },
                padding: '1rem'
            },
            header: {
                background: 'transparent',
                border: {
                    color: '#00000000',
                    radius: '0',
                    width: '0'
                },
                color: '{text.color}',
                gap: '0.5rem',
                padding: '1.125rem'
            },
            progressbar: {
                height: '1px'
            },
            transition: {
                duration: '{transition.duration}'
            }
        },
        galleria: {
            border: {
                color: '{content.border.color}',
                radius: '{content.border.radius}',
                width: '1px'
            },
            caption: {
                background: 'rgba(0, 0, 0, 0.5)',
                color: '{surface.100}',
                padding: '1rem'
            },
            close: {
                button: {
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: {
                        radius: '{galleria.close.button.size} / 2'
                    },
                    color: '{surface.50}',
                    focus: {
                        ring: {
                            color: '{focus.ring.color}',
                            offset: '{focus.ring.offset}',
                            shadow: '{focus.ring.shadow}',
                            style: '{focus.ring.style}',
                            width: '{focus.ring.width}'
                        }
                    },
                    gutter: '0.5rem',
                    hover: {
                        background: 'rgba(255, 255, 255, 0.2)',
                        color: '{surface.0}'
                    },
                    icon: {
                        size: '1.5rem'
                    },
                    size: '3rem'
                }
            },
            indicator: {
                button: {
                    active: {
                        background: '{primary.color}'
                    },
                    background: '{surface.700}',
                    border: {
                        radius: '{galleria.indicator.button.width} / 2'
                    },
                    focus: {
                        ring: {
                            color: '{focus.ring.color}',
                            offset: '{focus.ring.offset}',
                            shadow: '{focus.ring.shadow}',
                            style: '{focus.ring.style}',
                            width: '{focus.ring.width}'
                        }
                    },
                    height: '1rem',
                    hover: {
                        background: '{surface.600}'
                    },
                    width: '1rem'
                },
                list: {
                    gap: '0.5rem',
                    padding: '1rem'
                }
            },
            inset: {
                indicator: {
                    button: {
                        active: {
                            background: 'rgba(255, 255, 255, 0.9)'
                        },
                        background: 'rgba(255, 255, 255, 0.4)',
                        hover: {
                            background: 'rgba(255, 255, 255, 0.6)'
                        }
                    },
                    list: {
                        background: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            },
            nav: {
                button: {
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: '{surface.100}',
                    focus: {
                        ring: {
                            color: '{focus.ring.color}',
                            offset: '{focus.ring.offset}',
                            shadow: '{focus.ring.shadow}',
                            style: '{focus.ring.style}',
                            width: '{focus.ring.width}'
                        }
                    },
                    gutter: '0.5rem',
                    hover: {
                        background: 'rgba(255, 255, 255, 0.2)',
                        color: '{surface.0}'
                    },
                    next: {
                        border: {
                            radius: '{galleria.nav.button.size} / 2'
                        }
                    },
                    prev: {
                        border: {
                            radius: '{galleria.nav.button.size} / 2'
                        }
                    },
                    size: '3rem'
                },
                icon: {
                    size: '1.5rem'
                }
            },
            thumbnail: {
                nav: {
                    button: {
                        border: {
                            radius: '{content.border.radius}'
                        },
                        color: '{surface.400}',
                        focus: {
                            ring: {
                                color: '{focus.ring.color}',
                                offset: '{focus.ring.offset}',
                                shadow: '{focus.ring.shadow}',
                                style: '{focus.ring.style}',
                                width: '{focus.ring.width}'
                            }
                        },
                        gutter: '0.5rem',
                        hover: {
                            background: '{surface.700}',
                            color: '{surface.0}'
                        },
                        icon: {
                            size: '1rem'
                        },
                        size: '2rem'
                    }
                }
            },
            thumbnails: {
                content: {
                    background: '{content.background}',
                    padding: '1rem 0.25rem'
                }
            },
            transition: {
                duration: '{transition.duration}'
            }
        },
        inputtext: {
            background: '{form.field.background}',
            border: {
                color: '{form.field.border.color}',
                radius: '{form.field.border.radius}'
            },
            color: '{form.field.color}',
            disabled: {
                background: '{form.field.disabled.background}',
                color: '{form.field.disabled.color}'
            },
            filled: {
                background: '{form.field.filled.background}',
                focus: {
                    background: '{form.field.filled.focus.background}'
                },
                hover: {
                    background: '{form.field.filled.hover.background}'
                }
            },
            focus: {
                border: {
                    color: '{form.field.focus.border.color}'
                },
                ring: {
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                    style: '{form.field.focus.ring.style}',
                    width: '{form.field.focus.ring.width}'
                }
            },
            hover: {
                border: {
                    color: '{form.field.hover.border.color}'
                }
            },
            invalid: {
                border: {
                    color: '{form.field.invalid.border.color}'
                },
                placeholder: {
                    color: '{form.field.invalid.placeholder.color}'
                }
            },
            lg: {
                font: {
                    size: '1.125rem'
                },
                padding: {
                    x: '{form.field.lg.padding.x}',
                    y: '{form.field.lg.padding.y}'
                }
            },
            padding: {
                x: '{form.field.padding.x}',
                y: '{form.field.padding.y}'
            },
            placeholder: {
                color: '{form.field.placeholder.color}'
            },
            shadow: '{form.field.shadow}',
            sm: {
                font: {
                    size: '0.875rem'
                },
                padding: {
                    x: '{form.field.sm.padding.x}',
                    y: '{form.field.sm.padding.y}'
                }
            },
            transition: {
                duration: '{form.field.transition.duration}'
            }
        },
        menu: {
            background: '{content.background}',
            border: {
                color: '{content.border.color}',
                radius: '{content.border.radius}'
            },
            color: '{content.color}',
            item: {
                border: {
                    radius: '{navigation.item.border.radius}'
                },
                color: '{navigation.item.color}',
                focus: {
                    background: '{navigation.item.focus.background}',
                    color: '{navigation.item.focus.color}'
                },
                gap: '{navigation.item.gap}',
                icon: {
                    color: '{navigation.item.icon.color}',
                    focus: {
                        color: '{navigation.item.icon.focus.color}'
                    }
                },
                padding: '{navigation.item.padding}'
            },
            list: {
                gap: '{navigation.list.gap}',
                padding: '{navigation.list.padding}'
            },
            separator: {
                border: {
                    color: '{content.border.color}'
                }
            },
            shadow: '{overlay.navigation.shadow}',
            submenu: {
                label: {
                    background: '{navigation.submenu.label.background}',
                    color: '{navigation.submenu.label.color}',
                    font: {
                        weight: '{navigation.submenu.label.font.weight}'
                    },
                    padding: '{navigation.submenu.label.padding}'
                }
            },
            transition: {
                duration: '{transition.duration}'
            }
        },
        menubar: {
            background: '{content.background}',
            base: {
                item: {
                    border: {
                        radius: '{content.border.radius}'
                    },
                    padding: '{navigation.item.padding}'
                }
            },
            border: {
                color: '{content.border.color}',
                radius: '{content.border.radius}'
            },
            color: '{content.color}',
            gap: '0.5rem',
            item: {
                active: {
                    background: '{navigation.item.active.background}',
                    color: '{navigation.item.active.color}'
                },
                border: {
                    radius: '{navigation.item.border.radius}'
                },
                color: '{navigation.item.color}',
                focus: {
                    background: '{navigation.item.focus.background}',
                    color: '{navigation.item.focus.color}'
                },
                gap: '{navigation.item.gap}',
                icon: {
                    active: {
                        color: '{navigation.item.icon.active.color}'
                    },
                    color: '{navigation.item.icon.color}',
                    focus: {
                        color: '{navigation.item.icon.focus.color}'
                    }
                },
                padding: '{navigation.item.padding}'
            },
            mobile: {
                button: {
                    border: {
                        radius: '{menubar.mobile.button.size} / 2'
                    },
                    color: '{text.muted.color}',
                    focus: {
                        ring: {
                            color: '{focus.ring.color}',
                            offset: '{focus.ring.offset}',
                            shadow: '{focus.ring.shadow}',
                            style: '{focus.ring.style}',
                            width: '{focus.ring.width}'
                        }
                    },
                    hover: {
                        background: '{content.hover.background}',
                        color: '{text.hover.muted.color}'
                    },
                    size: '1.75rem'
                }
            },
            padding: '0.5rem 0.75rem',
            separator: {
                border: {
                    color: '{content.border.color}'
                }
            },
            submenu: {
                background: '{content.background}',
                border: {
                    color: '{content.border.color}',
                    radius: '{content.border.radius}'
                },
                gap: '{navigation.list.gap}',
                icon: {
                    active: {
                        color: '{navigation.submenu.icon.active.color}'
                    },
                    color: '{navigation.submenu.icon.color}',
                    focus: {
                        color: '{navigation.submenu.icon.focus.color}'
                    },
                    size: '{navigation.submenu.icon.size}'
                },
                mobile: {
                    indent: '1rem'
                },
                padding: '{navigation.list.padding}',
                shadow: '{overlay.navigation.shadow}'
            },
            transition: {
                duration: '{transition.duration}'
            }
        },
        message: {
            border: {
                radius: '{content.border.radius}',
                width: '1px'
            },
            close: {
                button: {
                    border: {
                        radius: '{message.close.button.width} / 2'
                    },
                    focus: {
                        ring: {
                            offset: '{focus.ring.offset}',
                            style: '{focus.ring.style}',
                            width: '{focus.ring.width}'
                        }
                    },
                    height: '1.75rem',
                    width: '1.75rem'
                },
                icon: {
                    lg: {
                        size: '1.125rem'
                    },
                    size: '1rem',
                    sm: {
                        size: '0.875rem'
                    }
                }
            },
            content: {
                gap: '0.5rem',
                lg: {
                    padding: '0.625rem 0.875rem'
                },
                padding: '0.5rem 0.75rem',
                sm: {
                    padding: '0.375rem 0.625rem'
                }
            },
            contrast: {
                background: '{surface.0}',
                border: {
                    color: '{surface.100}'
                },
                close: {
                    button: {
                        focus: {
                            ring: {
                                color: '{surface.950}',
                                shadow: 'none'
                            }
                        },
                        hover: {
                            background: '{surface.100}'
                        }
                    }
                },
                color: '{surface.950}',
                outlined: {
                    border: {
                        color: '{surface.0}'
                    },
                    color: '{surface.0}'
                },
                simple: {
                    color: '{surface.0}'
                }
            },
            error: {
                background: '{red.500}',
                border: {
                    color: '{red.700}'
                },
                close: {
                    button: {
                        focus: {
                            ring: {
                                color: '{red.500}',
                                shadow: 'none'
                            }
                        },
                        hover: {
                            background: 'rgba(255, 255, 255, 0.05)'
                        }
                    }
                },
                color: '{red.500}',
                outlined: {
                    border: {
                        color: '{red.500}'
                    },
                    color: '{red.500}'
                },
                simple: {
                    color: '{red.500}'
                }
            },
            icon: {
                lg: {
                    size: '1.25rem'
                },
                size: '1.125rem',
                sm: {
                    size: '1rem'
                }
            },
            info: {
                background: '{blue.500}',
                border: {
                    color: '{blue.700}'
                },
                close: {
                    button: {
                        focus: {
                            ring: {
                                color: '{blue.500}',
                                shadow: 'none'
                            }
                        },
                        hover: {
                            background: 'rgba(255, 255, 255, 0.05)'
                        }
                    }
                },
                color: '{blue.500}',
                outlined: {
                    border: {
                        color: '{blue.500}'
                    },
                    color: '{blue.500}'
                },
                simple: {
                    color: '{blue.500}'
                }
            },
            outlined: {
                border: {
                    width: '1px'
                }
            },
            secondary: {
                background: '{surface.800}',
                border: {
                    color: '{surface.700}'
                },
                close: {
                    button: {
                        focus: {
                            ring: {
                                color: '{surface.300}',
                                shadow: 'none'
                            }
                        },
                        hover: {
                            background: '{surface.700}'
                        }
                    }
                },
                color: '{surface.300}',
                outlined: {
                    border: {
                        color: '{surface.400}'
                    },
                    color: '{surface.400}'
                },
                simple: {
                    color: '{surface.400}'
                }
            },
            simple: {
                content: {
                    padding: '0'
                }
            },
            success: {
                background: 'red',
                border: {
                    color: '{green.700}'
                },
                close: {
                    button: {
                        focus: {
                            ring: {
                                color: '{green.500}',
                                shadow: 'none'
                            }
                        },
                        hover: {
                            background: 'rgba(255, 255, 255, 0.05)'
                        }
                    }
                },
                color: '{green.500}',
                outlined: {
                    border: {
                        color: '{green.500}'
                    },
                    color: '{green.500}'
                },
                simple: {
                    color: '{green.500}'
                }
            },
            text: {
                font: {
                    size: '1rem',
                    weight: '500'
                },
                lg: {
                    font: {
                        size: '1.125rem'
                    }
                },
                sm: {
                    font: {
                        size: '0.875rem'
                    }
                }
            },
            transition: {
                duration: '{transition.duration}'
            },
            warn: {
                background: '{yellow.500}',
                border: {
                    color: '{yellow.700}'
                },
                close: {
                    button: {
                        focus: {
                            ring: {
                                color: '{yellow.500}',
                                shadow: 'none'
                            }
                        },
                        hover: {
                            background: 'rgba(255, 255, 255, 0.05)'
                        }
                    }
                },
                color: '{yellow.500}',
                outlined: {
                    border: {
                        color: '{yellow.500}'
                    },
                    color: '{yellow.500}'
                },
                simple: {
                    color: '{yellow.500}'
                }
            }
        },
        multiselect: {
            background: '{form.field.background}',
            border: {
                color: '{form.field.border.color}',
                radius: '{form.field.border.radius}'
            },
            chip: {
                border: {
                    radius: '16px'
                }
            },
            clear: {
                icon: {
                    color: '{form.field.icon.color}'
                }
            },
            color: '{form.field.color}',
            disabled: {
                background: '{form.field.disabled.background}',
                color: '{form.field.disabled.color}'
            },
            dropdown: {
                color: '{form.field.icon.color}',
                width: '2.5rem'
            },
            empty: {
                message: {
                    padding: '{list.option.padding}'
                }
            },
            figma: {
                chip: {
                    padding: {
                        bottom: '{multiselect.padding.y} /2',
                        top: '{multiselect.padding.y}/2'
                    }
                },
                input: {
                    multiple: {
                        gap: '{multiselect.padding.y} /2'
                    }
                }
            },
            filled: {
                background: '{form.field.filled.background}',
                focus: {
                    background: '{form.field.filled.focus.background}'
                },
                hover: {
                    background: '{form.field.filled.hover.background}'
                }
            },
            focus: {
                border: {
                    color: '{form.field.focus.border.color}'
                },
                ring: {
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                    style: '{form.field.focus.ring.style}',
                    width: '{form.field.focus.ring.width}'
                }
            },
            header: {
                padding: '{list.header.padding}'
            },
            hover: {
                border: {
                    color: '{form.field.hover.border.color}'
                }
            },
            invalid: {
                border: {
                    color: '{form.field.invalid.border.color}'
                },
                placeholder: {
                    color: '{form.field.invalid.placeholder.color}'
                }
            },
            lg: {
                font: {
                    size: '{form.field.lg.font.size}'
                },
                padding: {
                    x: '{form.field.lg.padding.x}',
                    y: '{form.field.lg.padding.y}'
                }
            },
            list: {
                gap: '{list.gap}',
                header: {
                    padding: '{list.header.padding}'
                },
                padding: '{list.padding}'
            },
            option: {
                border: {
                    radius: '{list.option.border.radius}'
                },
                color: '{list.option.color}',
                focus: {
                    background: '{list.option.focus.background}',
                    color: '{list.option.focus.color}'
                },
                gap: '0.5rem',
                group: {
                    background: '{list.option.group.background}',
                    color: '{list.option.group.color}',
                    font: {
                        weight: '{list.option.group.font.weight}'
                    },
                    padding: '{list.option.group.padding}'
                },
                padding: '{list.option.padding}',
                selected: {
                    background: '{list.option.selected.background}',
                    color: '{list.option.selected.color}',
                    focus: {
                        background: '{list.option.selected.focus.background}',
                        color: '{list.option.selected.focus.color}'
                    }
                }
            },
            overlay: {
                background: '{overlay.select.background}',
                border: {
                    color: '{overlay.select.border.color}',
                    radius: '{overlay.select.border.radius}'
                },
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}'
            },
            padding: {
                x: '{form.field.padding.x}',
                y: '{form.field.padding.y}'
            },
            placeholder: {
                color: '{form.field.placeholder.color}'
            },
            shadow: '{form.field.shadow}',
            sm: {
                font: {
                    size: '{form.field.sm.font.size}'
                },
                padding: {
                    x: '{form.field.sm.padding.x}',
                    y: '{form.field.sm.padding.y}'
                }
            },
            transition: {
                duration: '{form.field.transition.duration}'
            }
        },
        panel: {
            background: '{content.background}',
            border: {
                color: '{content.border.color}',
                radius: '{content.border.radius}'
            },
            color: '{content.color}',
            content: {
                padding: '0 1.125rem 1.125rem 1.125rem'
            },
            footer: {
                padding: '0 1.125rem 1.125rem 1.125rem'
            },
            header: {
                background: 'transparent',
                border: {
                    color: '{content.border.color}',
                    radius: '0',
                    width: '0'
                },
                color: '{text.color}',
                padding: '1.125rem'
            },
            title: {
                font: {
                    weight: '600'
                }
            },
            toggleable: {
                header: {
                    padding: '0.375rem 1.125rem'
                }
            }
        },
        select: {
            background: '{form.field.background}',
            border: {
                color: '{form.field.border.color}',
                radius: '{form.field.border.radius}'
            },
            checkmark: {
                color: '{list.option.color}',
                gutter: {
                    end: '0.375rem',
                    start: '-0.375rem'
                }
            },
            clear: {
                icon: {
                    color: '{form.field.icon.color}'
                }
            },
            color: '{form.field.color}',
            disabled: {
                background: '{form.field.disabled.background}',
                color: '{form.field.disabled.color}'
            },
            dropdown: {
                color: '{form.field.icon.color}',
                width: '2.5rem'
            },
            empty: {
                message: {
                    padding: '{list.option.padding}'
                }
            },
            filled: {
                background: '{form.field.filled.background}',
                focus: {
                    background: '{form.field.filled.focus.background}'
                },
                hover: {
                    background: '{form.field.filled.hover.background}'
                }
            },
            focus: {
                border: {
                    color: '{form.field.focus.border.color}'
                },
                ring: {
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                    style: '{form.field.focus.ring.style}',
                    width: '{form.field.focus.ring.width}'
                }
            },
            hover: {
                border: {
                    color: '{form.field.hover.border.color}'
                }
            },
            invalid: {
                border: {
                    color: '{form.field.invalid.border.color}'
                },
                placeholder: {
                    color: '{form.field.invalid.placeholder.color}'
                }
            },
            lg: {
                font: {
                    size: '{form.field.lg.font.size}'
                },
                padding: {
                    x: '{form.field.lg.padding.x}',
                    y: '{form.field.lg.padding.y}'
                }
            },
            list: {
                gap: '0',
                header: {
                    padding: '{list.header.padding}'
                },
                padding: '{list.padding}'
            },
            option: {
                border: {
                    radius: '0'
                },
                color: '{list.option.color}',
                focus: {
                    background: '{list.option.focus.background}',
                    color: '{list.option.focus.color}'
                },
                group: {
                    background: '{list.option.group.background}',
                    color: '{list.option.group.color}',
                    font: {
                        weight: '{list.option.group.font.weight}'
                    },
                    padding: '{list.option.group.padding}'
                },
                padding: '{list.option.padding}',
                selected: {
                    background: '{list.option.selected.background}',
                    color: '{list.option.selected.color}',
                    focus: {
                        background: '{list.option.selected.focus.background}',
                        color: '{list.option.selected.focus.color}'
                    }
                }
            },
            overlay: {
                background: '{overlay.select.background}',
                border: {
                    color: '{overlay.select.border.color}',
                    radius: '{overlay.select.border.radius}'
                },
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}'
            },
            padding: {
                x: '{form.field.padding.x}',
                y: '{form.field.padding.y}'
            },
            placeholder: {
                color: '{form.field.placeholder.color}'
            },
            shadow: '{form.field.shadow}',
            sm: {
                font: {
                    size: '{form.field.sm.font.size}'
                },
                padding: {
                    x: '{form.field.sm.padding.x}',
                    y: '{form.field.sm.padding.y}'
                }
            },
            transition: {
                duration: '{form.field.transition.duration}'
            }
        },
        tabs: {
            active: {
                bar: {
                    background: '{primary.color}',
                    bottom: '-1px',
                    height: '1px'
                }
            },
            nav: {
                button: {
                    background: '{content.background}',
                    color: '{text.muted.color}',
                    focus: {
                        ring: {
                            color: '{focus.ring.color}',
                            offset: '-1',
                            shadow: '{focus.ring.shadow}',
                            style: '{focus.ring.style}',
                            width: '{focus.ring.width}'
                        }
                    },
                    hover: {
                        color: '{text.color}'
                    },
                    width: '2.5rem'
                }
            },
            tab: {
                active: {
                    background: 'transparent',
                    border: {
                        color: '{primary.color}'
                    },
                    color: '{primary.color}'
                },
                background: 'transparent',
                border: {
                    color: '{content.border.color}',
                    width: '1',
                    radius: '0px'
                },
                color: '{text.muted.color}',
                focus: {
                    ring: {
                        color: '{focus.ring.color}',
                        offset: '-1',
                        shadow: '{focus.ring.shadow}',
                        style: '{focus.ring.style}',
                        width: '{focus.ring.width}'
                    }
                },
                font: {
                    weight: '600'
                },
                gap: '0.5rem',
                hover: {
                    background: 'transparent',
                    border: {
                        color: '{content.border.color}'
                    },
                    color: '{text.color}'
                },
                margin: '0 0 -1px 0',
                padding: '8px 12px'
            },
            tablist: {
                background: '{content.background}',
                border: {
                    color: '{content.border.color}',
                    width: '0'
                }
            },
            tabpanel: {
                background: '{content.background}',
                color: '{content.color}',
                focus: {
                    ring: {
                        color: '{focus.ring.color}',
                        offset: '{focus.ring.offset}',
                        shadow: '{focus.ring.shadow}',
                        style: '{focus.ring.style}',
                        width: '{focus.ring.width}'
                    }
                },
                padding: '0.875rem 1.125rem 1.125rem 1.125rem'
            },
            transition: {
                duration: '{transition.duration}'
            }
        },
        tag: {
            border: {
                radius: '{content.border.radius}'
            },
            contrast: {
                background: '{surface.0}',
                color: '{surface.950}'
            },
            danger: {
                background: '{red.500}',
                color: '{red.300}'
            },
            figma: {
                container: {
                    background: 'rgba(0, 0, 0, 0.7)'
                }
            },
            font: {
                size: '0.875rem',
                weight: '700'
            },
            gap: '0.25rem',
            icon: {
                size: '0.75rem'
            },
            info: {
                background: '{sky.500}',
                color: '{sky.300}'
            },
            padding: '0.25rem 0.5rem',
            primary: {
                background: '{primary.500}',
                color: '{primary.300}'
            },
            rounded: {
                border: {
                    radius: '{border.radius.xl}'
                }
            },
            secondary: {
                background: '{surface.800}',
                color: '{surface.300}'
            },
            success: {
                background: '{green.500}',
                color: '{green.300}'
            },
            warn: {
                background: '{orange.500}',
                color: '{orange.300}'
            }
        },
        textarea: {
            root: {
                borderRadius: '12px'
            },
            background: '{form.field.background}',
            border: {
                color: '{form.field.border.color}',
                radius: '{form.field.border.radius}'
            },
            color: '{form.field.color}',
            disabled: {
                background: '{form.field.disabled.background}',
                color: '{form.field.disabled.color}'
            },
            filled: {
                background: '{form.field.filled.background}',
                focus: {
                    background: '{form.field.filled.focus.background}'
                },
                hover: {
                    background: '{form.field.filled.hover.background}'
                }
            },
            focus: {
                border: {
                    color: '{form.field.focus.border.color}'
                },
                ring: {
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                    style: '{form.field.focus.ring.style}',
                    width: '{form.field.focus.ring.width}'
                }
            },
            hover: {
                border: {
                    color: '{form.field.hover.border.color}'
                }
            },
            invalid: {
                border: {
                    color: '{form.field.invalid.border.color}'
                },
                placeholder: {
                    color: '{form.field.invalid.placeholder.color}'
                }
            },
            lg: {
                font: {
                    size: '{form.field.lg.font.size}'
                },
                padding: {
                    x: '{form.field.lg.padding.x}',
                    y: '{form.field.lg.padding.y}'
                }
            },
            padding: {
                x: '{form.field.padding.x}',
                y: '{form.field.padding.y}'
            },
            placeholder: {
                color: '{form.field.placeholder.color}'
            },
            shadow: '{form.field.shadow}',
            sm: {
                font: {
                    size: '{form.field.sm.font.size}'
                },
                padding: {
                    x: '{form.field.sm.padding.x}',
                    y: '{form.field.sm.padding.y}'
                }
            },
            transition: {
                duration: '{form.field.transition.duration}'
            }
        },
        tieredmenu: {
            background: '{content.background}',
            border: {
                color: '{content.border.color}',
                radius: '{content.border.radius}'
            },
            color: '{content.color}',
            item: {
                active: {
                    background: '{navigation.item.active.background}',
                    color: '{navigation.item.active.color}'
                },
                border: {
                    radius: '{navigation.item.border.radius}'
                },
                color: '{navigation.item.color}',
                focus: {
                    background: '{navigation.item.focus.background}',
                    color: '{navigation.item.focus.color}'
                },
                gap: '{navigation.item.gap}',
                icon: {
                    active: {
                        color: '{navigation.item.icon.active.color}'
                    },
                    color: '{navigation.item.icon.color}',
                    focus: {
                        color: '{navigation.item.icon.focus.color}'
                    }
                },
                padding: '{navigation.item.padding}'
            },
            list: {
                gap: '{navigation.list.gap}',
                padding: '{navigation.list.padding}'
            },
            separator: {
                border: {
                    color: '{content.border.color}'
                }
            },
            shadow: '{overlay.navigation.shadow}',
            submenu: {
                icon: {
                    active: {
                        color: '{navigation.submenu.icon.active.color}'
                    },
                    color: '{navigation.submenu.icon.color}',
                    focus: {
                        color: '{navigation.submenu.icon.focus.color}'
                    },
                    size: '{navigation.submenu.icon.size}'
                },
                mobile: {
                    indent: '1rem'
                }
            },
            transition: {
                duration: '{transition.duration}'
            }
        },
        tree: {
            background: '{content.background}',
            color: '{content.color}',
            filter: {
                margin: '0.5rem'
            },
            gap: '2px',
            indent: '1rem',
            loading: {
                icon: {
                    size: '2rem'
                }
            },
            node: {
                border: {
                    radius: '0px'
                },
                color: '{text.color}',
                focus: {
                    ring: {
                        color: '{focus.ring.color}',
                        offset: '-1px',
                        shadow: '{focus.ring.shadow}',
                        style: '{focus.ring.style}',
                        width: '{focus.ring.width}'
                    }
                },
                gap: '0',
                hover: {
                    background: '{content.hover.background}',
                    color: '{text.hover.color}'
                },
                icon: {
                    color: '{text.muted.color}',
                    hover: {
                        color: '{text.hover.muted.color}'
                    },
                    selected: {
                        color: '{highlight.color}'
                    }
                },
                padding: '0',
                selected: {
                    background: '{highlight.background}',
                    color: '{highlight.color}'
                },
                toggle: {
                    button: {
                        border: {
                            radius: '{tree.node.toggle.button.size} / 2'
                        },
                        color: '{text.muted.color}',
                        focus: {
                            ring: {
                                color: '{focus.ring.color}',
                                offset: '{focus.ring.offset}',
                                shadow: '{focus.ring.shadow}',
                                style: '{focus.ring.style}',
                                width: '{focus.ring.width}'
                            }
                        },
                        hover: {
                            background: '{content.hover.background}',
                            color: '{text.hover.muted.color}'
                        },
                        selected: {
                            hover: {
                                background: '{content.background}',
                                color: '{primary.color}'
                            }
                        },
                        size: '1.75rem'
                    }
                }
            },
            padding: '0px',
            transition: {
                duration: '{transition.duration}'
            }
        },
        treeselect: {
            background: '{form.field.background}',
            border: {
                color: '{form.field.border.color}',
                radius: '{form.field.border.radius}'
            },
            chip: {
                border: {
                    radius: '20px'
                }
            },
            clear: {
                icon: {
                    color: '{form.field.icon.color}'
                }
            },
            color: '{form.field.color}',
            disabled: {
                background: '{form.field.disabled.background}',
                color: '{form.field.disabled.color}'
            },
            dropdown: {
                color: '{form.field.icon.color}',
                width: '2.5rem'
            },
            empty: {
                message: {
                    padding: '{list.option.padding}'
                }
            },
            figma: {
                chip: {
                    padding: {
                        bottom: '{treeselect.padding.y} /2',
                        top: '{treeselect.padding.y}/2'
                    }
                },
                input: {
                    multiple: {
                        gap: '{treeselect.padding.y} /2'
                    }
                }
            },
            filled: {
                background: '{form.field.filled.background}',
                focus: {
                    background: '{form.field.filled.focus.background}'
                },
                hover: {
                    background: '{form.field.filled.hover.background}'
                }
            },
            focus: {
                border: {
                    color: '{form.field.focus.border.color}'
                },
                ring: {
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                    style: '{form.field.focus.ring.style}',
                    width: '{form.field.focus.ring.width}'
                }
            },
            hover: {
                border: {
                    color: '{form.field.hover.border.color}'
                }
            },
            invalid: {
                border: {
                    color: '{form.field.invalid.border.color}'
                },
                placeholder: {
                    color: '{form.field.invalid.placeholder.color}'
                }
            },
            lg: {
                font: {
                    size: '{form.field.lg.font.size}'
                },
                padding: {
                    x: '{form.field.lg.padding.x}',
                    y: '{form.field.lg.padding.y}'
                }
            },
            overlay: {
                background: '{overlay.select.background}',
                border: {
                    color: '{overlay.select.border.color}',
                    radius: '{overlay.select.border.radius}'
                },
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}'
            },
            padding: {
                x: '{form.field.padding.x}',
                y: '{form.field.padding.y}'
            },
            placeholder: {
                color: '{form.field.placeholder.color}'
            },
            shadow: '{form.field.shadow}',
            sm: {
                font: {
                    size: '{form.field.sm.font.size}'
                },
                padding: {
                    x: '{form.field.sm.padding.x}',
                    y: '{form.field.sm.padding.y}'
                }
            },
            transition: {
                duration: '{form.field.transition.duration}'
            },
            tree: {
                padding: '{list.padding}'
            }
        }
    }
});

const theme = {
    preset: MyPreset,
    options: {
        prefix: 'p',
        cssLayer: false,
        darkModeSelector: false
    }
};

export default theme;
